module.exports = __webpack_public_path__ + "static/media/architecture-highlights.742809f8.md";